import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/Home";
import AboutPage from "./components/AboutPage";
import DevelopmentPage from "./components/DevelopmentPage";
import ProgramsPage from "./components/ProgramsPage";
import PartnershipsPage from "./components/PartnershipsPage";
import ContactPage from "./components/ContactPage";
import ProgramDashboard from "./components/ProgramDashboard";
import ResourceCenter from "./components/ResourceCenter";
import RentersResources from "./components/RentersResources";
import HomelessnessResources from "./components/HomelessnessResources";
import HomeownersResources from "./components/HomeownersResources";
import ScrollToTop from "./components/ScrollToTop";
import FinancialResources from "./components/FinancialResources";
import BudgetCalculator from "./components/BudgetCalculator";
import MoveInChecklist from "./components/printable/MoveInChecklist";
import BudgetWorksheet from "./components/printable/BudgetWorksheet";
import MaintenanceGuide from "./components/printable/MaintenanceGuide";
import MoveInPlan from "./components/printable/MoveInPlan";
import RentReadinessQuiz from "./components/RentReadinessQuiz";
import SpotTheUnfairLease from "./components/SpotTheUnfairLease";
import { CaseStudiesHub, CaseStudyDetail } from "./components/CaseStudies";
import ApartmentShopping from "./components/ApartmentShopping";
import MoveInRealityCheck from "./components/MoveInRealityCheck";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/development" element={<DevelopmentPage />} />
          {/* Backwards compatibility: old /services route redirects to /development */}
          <Route path="/services" element={<Navigate to="/development" replace />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/partnerships" element={<PartnershipsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/resources" element={<ResourceCenter />} />
          <Route path="/resources/renters" element={<RentersResources />} />
          <Route path="/resources/renters/calculator" element={<BudgetCalculator />} />
          <Route path="/resources/renters/move-in-checklist" element={<MoveInChecklist />} />
          <Route path="/resources/renters/budget-worksheet" element={<BudgetWorksheet />} />
          <Route path="/resources/renters/maintenance-guide" element={<MaintenanceGuide />} />
          <Route path="/quiz/rent-readiness" element={<RentReadinessQuiz />} />
          <Route path="/games/spot-the-unfair-lease" element={<SpotTheUnfairLease />} />
          <Route path="/games/lease-detective" element={<SpotTheUnfairLease />} />
          <Route path="/games/apartment-shopping" element={<ApartmentShopping />} />
          <Route path="/tools/move-in-reality-check" element={<MoveInRealityCheck />} />
          <Route path="/tools/move-in-plan" element={<MoveInPlan />} />
          <Route path="/stories/case-studies" element={<CaseStudiesHub />} />
          <Route path="/stories/:slug" element={<CaseStudyDetail />} />
          <Route path="/resources/homelessness" element={<HomelessnessResources />} />
          <Route path="/resources/homeowners" element={<HomeownersResources />} />
          <Route path="/resources/financial" element={<FinancialResources />} />
          <Route path="/admin" element={<ProgramDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
